export const validateEmptyString = (value = '') => {
  return value.trim() === ''
}
